import { useEffect, useState } from 'react';
import { Button, Grid, Container, CardActions, Select, MenuItem, TextField, Box } from '@mui/material';
import { UserCard } from './UserCard';
import { traineeApi, userApi } from '@/generated/clients';
import { Trainee, UserDTO } from '@/generated';

const getSortBy = () => localStorage.getItem('sortBy');
const setSortBy = (sortBy: string) => localStorage.setItem('sortBy', sortBy);

export const TraineeAssignment = () => {
  const [userList, setUserList] = useState<Array<UserDTO>>();
  const [userSortFilter, setUserSortFilter] = useState<string | null | undefined>(getSortBy() ?? undefined);
  const [assignFilter, setAssignFilter] = useState<string | null | undefined>(undefined);
  const [userSearchText, setUserSearchText] = useState<string>('');
  const [trainees, setTrainees] = useState<Trainee[]>([]);
  const [selectedTrainer, setSelectedTrainer] = useState<UserDTO>();

  const getTrainees = async () => {
    if (selectedTrainer) {
      const trainees = await traineeApi.traineeManagementListTraineesForTrainerId({ id: selectedTrainer.userId });
      setTrainees(trainees);
    }
  };

  useEffect(() => {
    if (!userList) {
      const getUsers = async () => {
        const users = await userApi.userListUsers();
        setUserList(users);
      };
      getUsers();
    }
  }, []);

  useEffect(() => {
    getTrainees();
  }, [selectedTrainer]);

  let filteredUsers = userList;

  if (userSortFilter === 'lastLogin')
    filteredUsers = userList?.sort((a, b) => {
      const aTime = a.lastLogin ? new Date(a.lastLogin).getTime() : 0;
      const bTime = b.lastLogin ? new Date(b.lastLogin).getTime() : 0;

      return aTime > bTime ? -1 : 1;
    });
  else if (userSortFilter === 'name')
    filteredUsers = userList?.sort((a, b) => {
      if (a.username && b.username) return a.username > b.username ? 1 : -1;
      return a.email > b.email ? 1 : -1;
    });
  else if (userSortFilter === 'none') filteredUsers = userList;
  if (userSearchText.trim().length)
    filteredUsers = filteredUsers?.filter((fu) => {
      return (fu.username?.includes(userSearchText.trim()) ?? false) || fu.email.includes(userSearchText.trim());
    });
  const trainers = filteredUsers?.filter((u) => u.roles.includes('trainer'));

  filteredUsers = filteredUsers?.filter((fu) => {
    if (!selectedTrainer) return true;
    if (assignFilter === 'assigned') return trainees.some((t) => t.userId === fu.userId);
    else if (assignFilter === 'unassigned') return !trainees.some((t) => t.userId === fu.userId);
    return true;
  });

  const users = selectedTrainer ? filteredUsers : trainers;

  return (
    <>
      <Container>
        <Box sx={{ m: 1 }}>Selected Trainer {!selectedTrainer ? 'None' : selectedTrainer.username}</Box>
        Sort by
        <Select
          defaultValue={'none'}
          sx={{ m: 2 }}
          value={userSortFilter}
          onChange={(e) => {
            setUserSortFilter(e.target.value);
            if (e.target.value) setSortBy(e.target.value);
          }}
        >
          <MenuItem value={'none'}>Nothing</MenuItem>
          <MenuItem value={'lastLogin'}>Last Login</MenuItem>
          <MenuItem value={'name'}>User Name</MenuItem>
        </Select>
        Filter by
        <Select
          defaultValue={'none'}
          sx={{ m: 2 }}
          value={userSortFilter}
          onChange={(e) => {
            setAssignFilter(e.target.value);
          }}
        >
          <MenuItem value={'none'}>None</MenuItem>
          <MenuItem value={'assigned'}>Assigned</MenuItem>
          <MenuItem value={'unassigned'}>Unassigned</MenuItem>
        </Select>
        <TextField value={userSearchText} onChange={(e: any) => setUserSearchText(e.target.value)} sx={{ m: 2 }} id="outlined-basic" label="Search" variant="outlined" />
        <Grid container direction={'row'} spacing={2}>
          {users?.map((u) => (
            <Grid size={{ xs: 12, md: 4 }}>
              <UserCard onClick={() => {}} user={u} timeout={1000}>
                <CardActions>
                  {!selectedTrainer && (
                    <Button
                      onClick={async () => {
                        setSelectedTrainer(u);
                      }}
                      style={{}}
                    >
                      Select Trainer
                    </Button>
                  )}
                  {selectedTrainer && !trainees.some((t) => t.userId === u.userId) && (
                    <Button
                      onClick={async () => {
                        await traineeApi.traineeManagementAssignTrainee({ assignTrainee: { traineeId: u.userId, trainerId: selectedTrainer.userId } });
                        getTrainees();
                      }}
                      style={{}}
                    >
                      Assign Trainee
                    </Button>
                  )}
                  {selectedTrainer && trainees.some((t) => t.userId === u.userId) && (
                    <Button
                      onClick={async () => {
                        await traineeApi.traineeManagementUnAssignTrainee({ assignTrainee: { traineeId: u.userId, trainerId: selectedTrainer.userId } });
                        getTrainees();
                      }}
                      style={{}}
                    >
                      Unassign Trainee
                    </Button>
                  )}
                </CardActions>
              </UserCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};
